import React, { useState, useEffect } from 'react';
//import Switch from 'react-switch';
import { Switch, message } from 'antd';
import OpenAI from "openai";
import {Select, Modal, Typography, Button, Radio,Checkbox, Image, Input, Tooltip, Divider} from 'antd';
import {template_options, font_style, background_design_elements, design_options, color_pallete} from '../Common/static.js';
import Pallette from './Pallette.jsx';
import { useSelector, useDispatch } from 'react-redux';
import { changeColorPalletes,changeSlideCount, changeTemplate, changeFontStyle, changeBackgroundDesign, updateSlideContent, changeFontSize, changeFontWeight, changeFontAlignment } from '../Store/allreducer.js';
import {FontColorsOutlined, AlignLeftOutlined, AlignCenterOutlined, InfoCircleOutlined, PlusOutlined, MinusOutlined, LockOutlined } from '@ant-design/icons'

const sideScreenStyles = {
  container: {
    backgroundColor: '#f8fafc',
    borderLeft: '1px solid #e2e8f0',
    height: '100vh',
    overflow: 'auto',
    padding: '1.5rem',
  },
  section: {
    marginBottom: '2rem',
  },
  sectionTitle: {
    fontSize: '0.875rem',
    fontWeight: '600',
    color: '#475569',
    marginBottom: '1rem',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  optionsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
    gap: '1rem',
    marginBottom: '1.5rem',
  },
  optionCard: {
    border: '1px solid #e2e8f0',
    borderRadius: '0.5rem',
    padding: '0.75rem',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    backgroundColor: 'white',
  },
  selectedCard: {
    borderColor: '#6366f1',
    backgroundColor: '#eef2ff',
    boxShadow: '0 0 0 2px #c7d2fe',
  },
  divider: {
    height: '1px',
    backgroundColor: '#e2e8f0',
    margin: '2rem 0',
  }
};

const { TextArea } = Input;

export const generateContent = async (prompt, slideCount) => {
  // Dummy API call - simulating async behavior
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  // Dummy response data
  const dummyResponses = [
    {
      tagline: "Transform Your Social Media Game",
      title: "<c>10 Proven Strategies</c> to Boost Your LinkedIn Engagement",
      paragraph: "Ready to take your LinkedIn presence to the next level? Let's dive into battle-tested strategies that actually work."
    },
    {
      tagline: "Strategy #1",
      title: "Create <c>Compelling Carousel</c> Posts",
      paragraph: `
        Carousels receive <b>3x more engagement</b> than single-image posts. Here's how to make yours stand out:
        <ul>
          <li><b>Use a hook:</b> Start with an attention-grabbing slide.</li>
          <li><b>Keep it structured:</b> Use a clear flow (intro, main content, conclusion).</li>
          <li><b>Mix text & visuals:</b> Too much text is overwhelming—balance it with graphics.</li>
          <li><b>End with a CTA:</b> Encourage comments, shares, or downloads.</li>
        </ul>
      `
    },
    {
      tagline: "Strategy #2",
      title: "Optimize Your <c>Posting Schedule</c>",
      paragraph: `
        When you post matters just as much as what you post. To maximize reach:
        <ul>
          <li><b>Post at peak hours:</b> Tuesday–Thursday, <b>8 AM to 2 PM</b> sees the highest engagement.</li>
          <li><b>Leverage analytics:</b> Check LinkedIn insights to see when your audience is most active.</li>
          <li><b>Be consistent:</b> Posting at the same time builds audience anticipation.</li>
          <li><b>Experiment:</b> Test different times and measure performance over weeks.</li>
        </ul>
      `
    },
    {
      tagline: "Strategy #3",
      title: "Engage With Your <c>Network Effectively</c>",
      paragraph: `
        Engagement isn't just about posting—it's about interacting with others. Try this:
        <ul>
          <li><b>Comment daily:</b> Spend at least <b>15 minutes</b> engaging with relevant posts.</li>
          <li><b>Ask questions:</b> Thoughtful comments spark discussions and visibility.</li>
          <li><b>Reply to DMs:</b> Responding quickly builds trust and opportunities.</li>
          <li><b>Tag others:</b> Mentioning relevant people expands your reach.</li>
        </ul>
      `
    },
    {
      tagline: "Strategy #4",
      title: "Use <c>Storytelling</c> to Connect",
      paragraph: `
        Stories create emotional connections and make posts memorable. Here's how:
        <ul>
          <li><b>Share personal experiences:</b> People relate to real-life challenges and wins.</li>
          <li><b>Follow a narrative structure:</b> Hook, conflict, resolution.</li>
          <li><b>Keep it authentic:</b> Avoid generic corporate speak—be yourself.</li>
          <li><b>Encourage engagement:</b> Ask readers if they've had similar experiences.</li>
        </ul>
      `
    },
    {
      tagline: "Strategy #5",
      title: "Leverage <c>LinkedIn Polls</c> for Engagement",
      paragraph: `
        Polls are a quick way to generate interaction. Here's how to use them effectively:
        <ul>
          <li><b>Ask thought-provoking questions:</b> Avoid yes/no answers; aim for discussion.</li>
          <li><b>Keep it relevant:</b> Tie polls to industry trends or audience interests.</li>
          <li><b>Analyze results:</b> Use responses to create follow-up content.</li>
          <li><b>Engage with voters:</b> Reply to comments and encourage discussion.</li>
        </ul>
      `
    },
    {
      tagline: "Strategy #6",
      title: "Collaborate With <c>Industry Leaders</c>",
      paragraph: `
        Partnering with influencers or experts can amplify your reach:
        <ul>
          <li><b>Feature guest content:</b> Interviews, Q&As, or co-authored posts.</li>
          <li><b>Engage with their content:</b> Commenting boosts visibility.</li>
          <li><b>Host live sessions:</b> Webinars or LinkedIn Lives attract more engagement.</li>
          <li><b>Give shoutouts:</b> Highlight insights from industry leaders.</li>
        </ul>
      `
    },
    {
      tagline: "Strategy #7",
      title: "Repurpose Your <c>Best-Performing Content</c>",
      paragraph: `
        Don't let great content fade away—reuse it in different formats:
        <ul>
          <li><b>Turn blogs into carousels:</b> Break long posts into digestible slides.</li>
          <li><b>Summarize videos into posts:</b> Key takeaways in text form.</li>
          <li><b>Create Twitter threads:</b> Repurpose insights for a wider audience.</li>
          <li><b>Update old posts:</b> Refresh data and repost with new insights.</li>
        </ul>
      `
    },
    {
      tagline: "Strategy #8",
      title: "Repurpose Your <c>Best-Performing Content</c>",
      paragraph: `
        Don't let great content fade away—reuse it in different formats:
        <ul>
          <li><b>Turn blogs into carousels:</b> Break long posts into digestible slides.</li>
          <li><b>Summarize videos into posts:</b> Key takeaways in text form.</li>
          <li><b>Create Twitter threads:</b> Repurpose insights for a wider audience.</li>
          <li><b>Update old posts:</b> Refresh data and repost with new insights.</li>
        </ul>
      `
    },
    {
      tagline: "Take Action Now",
      title: "Start Implementing These <c>Strategies</c> Today",
      paragraph: "Don't wait to improve your LinkedIn presence. Begin with one strategy and build from there. Your future self will thank you."
    }
];

  
  const validSlideCount = Math.min(Math.max(slideCount, 2), 10);
  
  // Always include first and last slides
  const firstSlide = dummyResponses[0];
  const lastSlide = dummyResponses[dummyResponses.length - 1];
  
  if (validSlideCount === 2) {
    // If only 2 slides requested, return first and last
    return [firstSlide, lastSlide];
  }

  // Return only the number of slides requested
  const middleSlides = dummyResponses.slice(1, -1)
    .slice(0, validSlideCount - 2);
  
  // Combine first, middle, and last slides
  return [firstSlide, ...middleSlides, lastSlide];
};

const SideScreen = ({ isMobile=false, subscription, userData }) => {
 
  const [number_of_slides, set_number_of_slides] = useState(5);
  const [template_type, set_template_type] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fontStyle, setFontStyle] = useState('');
  const [font_size, setFont_size] = useState('');
  const [BackgroundDesign, setBackgroundDesign] = useState('');
  const [alignment, setAlignment] = useState('left-alignment');
  const [branding, setBranding] = useState('');
  const [checkboxtick, setCheckboxtick] = useState(false);
  const [contentPrompt, setContentPrompt] = useState('');

  const [allow_background_design, setAllow_background_design] = useState(false);
  const [allow_slides_counter, setAllow_slides_counter] = useState(false);
  const [allow_branding, setAllow_branding] = useState(false);
  const [allow_headshot, setAllow_headshot] = useState(false);
  const [allow_name, setAllow_name] = useState(false);
  const [allow_handle_website, setAllow_handle_website] = useState(false);
  const [loading, setLoading] = useState(false);

  const {Text} = Typography;

  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [prompt, setPrompt] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  
  // console.log('template_type',template_options)

  const { slideCount, template, fontStyles, backgroundDesign} = useSelector(
    (state) => state.counter,
  );
  const { currentColorPalletes} = useSelector(
    (state) => state.counter,
  );
  const dataOfTemplate = useSelector(
    (state) => state,
  );
 // console.log('dataOfTemplate',dataOfTemplate)
// console.log('template_type8888888888888',template)
  const dispatch = useDispatch();

  useEffect(() => {
     set_number_of_slides(slideCount)
     set_template_type(template )
     setFontStyle(fontStyles)
     setBackgroundDesign(backgroundDesign)    
     setSelectedTemplate(template)
     
  },[slideCount, template, fontStyles, backgroundDesign,selectedTemplate]);
useEffect(()=>{
  handleFirstRender();
},[])

const handledisableAIGenerate = () =>{
  if(userData?.subscription === false){
    return true;
  }
  if(userData?.subscription === true && loading){
  return true;
}
  return false;
}

const handleRandomize = async () =>{
  const randomTemplate =    design_options[Math.floor(Math.random() * design_options.length)];
  let template_data = {
    ...template,
    pattern: randomTemplate?.pattern,
    patternUrl: randomTemplate?.patternUrl
  }
//  console.log('template_data==>',template_data)
  setSelectedTemplate(template_data);
  dispatch(changeTemplate(template_data));
  dispatch(changeColorPalletes({currentColorPalletes: color_pallete[Math.floor(Math.random() * color_pallete.length)]}))
}

const handleAIGenerate = async () =>{
  setLoading(true);
  const openai = new OpenAI({
    baseURL: 'https://api.deepseek.com',
    apiKey: 'sk-904bc608c938407688b65125d803d159',
    dangerouslyAllowBrowser: true 
});


const completion = await openai.chat.completions.create({
messages: [{ role: "system", content: `Generate array of ${number_of_slides} slides for a carousel post on LinkedIn for topic: ${contentPrompt}. Each array element should be an object with tagline, title, and paragraph properties. Added quotes around all property names (tagline, title, paragraph)
Ensured proper JSON formatting with double quotes instead of single quotes. Paragraph can be a bit long and takes html tags so make use of strong and lists . But be sure to add <c></c> tags in every title to give an accent like: This is a <c>title</c> ` }],
model: "deepseek-chat",
});

console.log(completion.choices[0].message.content, typeof completion.choices[0].message.content);
//'''json extract this part
const matchStart = completion.choices[0].message.content.indexOf('[')
console.log('matchStart==>',matchStart);
const matchEnd = completion.choices[0].message.content.indexOf(']') + 1;
console.log('matchEnd==>',matchEnd);
const jsonString = completion.choices[0].message.content.substring(matchStart, matchEnd);
console.log('jsonString==>',jsonString);
if (matchStart !== -1 && matchEnd !== -1) {
    try{
      console.log('jsonString==>',jsonString, typeof jsonString);
        const data = JSON.parse(jsonString);
        console.log('data==>', data);
        dispatch(updateSlideContent(data));
        setLoading(false);
    } catch (error) {
        console.error("Error parsing JSON:", error);
        setLoading(false);
    }
    
} else {
    console.log("No JSON found in the content.");
    setLoading(false);
}

}

  // Template selection modal content
  const TemplateSelector = () => (
    <div style={sideScreenStyles.optionsGrid}>
      {design_options.map((design, index) => (
        <div
          key={index}
          onClick={() => {
           // console.log('template==>',template,"selectedTemplate==>",selectedTemplate,"design==>",design)
            let template_data = {
              ...template,
              pattern: design?.pattern,
              patternUrl: design?.patternUrl
            }
          //  console.log('template_data==>',template_data)
            setSelectedTemplate(template_data);
            dispatch(changeTemplate(template_data));
          }}
          style={{
            ...sideScreenStyles.optionCard,
            ...(selectedTemplate.pattern === design?.pattern ? sideScreenStyles.selectedCard : {})
          }}
        >
          <div className="relative aspect-square">
            <div 
              className="w-full h-full"
              style={{
                backgroundColor: currentColorPalletes?.first_color || '#6941C6',
                position: 'relative'
              }}
            >
              {/* Pattern Preview */}
              <div 
                className="absolute inset-0"
                style={{
                  backgroundImage: `url("${design?.patternUrl}")`,
                  backgroundRepeat: 'repeat',
                  opacity: 0.2,
                  backgroundColor: currentColorPalletes?.third_color || '#FFB4E4',
                  maskImage: `url("${design?.patternUrl}")`,
                  WebkitMaskImage: `url("${design?.patternUrl}")`,
                }}
              />
              <div className="absolute inset-0 flex items-center justify-center text-white text-sm">
                {design?.pattern}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  const handleFirstRender = async () =>{
    try {
      const content = await generateContent(prompt, slideCount);
      //console.log('Generated content:', content); // Debug log
      
      // Dispatch the content update
      dispatch(updateSlideContent(content));
      
     // message.destroy();
      //message.success('Content generated successfully!');
    } catch (error) {
      console.error('Error generating content:', error);
     // message.destroy();
     // message.error('Failed to generate content. Please try again.');
    }
  }
  const handleGenerate = async (numSlides) => {
    // if (!prompt.trim()) {
    //   message.warning('Please enter a prompt first');
    //   return;
    // }

    setIsGenerating(true);
    message.loading('Generating content...', 0);

    try {
      const content = await generateContent("dummy", numSlides);
      //console.log('Generated content==>:', content); // Debug log
      
      // Dispatch the content update
      await dispatch(updateSlideContent(content));
      
      message.destroy();
      message.success('Content generated successfully!');
    } catch (error) {
      console.error('Error generating content:', error);
      message.destroy();
      message.error('Failed to generate content. Please try again.');
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="h-full p-6 overflow-y-auto bg-white">
      {/* Main content wrapper */}
      <div className="space-y-8">
        {/* Section: Carousel Generator */}
        <div>
          <h3 className="flex items-center gap-2 text-base font-semibold mb-4 text-gray-800">
            <span>✨ Carousel Generator</span>
          </h3>
          <div className="space-y-4">
            <div>
              <label className="flex items-center text-sm text-gray-600 mb-2">
                🎯 Number of Slides
                <Tooltip title="Enter the number of slides (2-10)">
                  <InfoCircleOutlined className="ml-2 text-gray-400 text-xs" />
                </Tooltip>
              </label>
              <input
                type='number'
                placeholder='Enter slides count'
                style={{width:'50%'}}
                value={number_of_slides}
                disabled={true}
                className="w-full h-10 px-4 rounded-lg border border-gray-200 focus:border-purple-400 focus:ring-1 focus:ring-purple-200 transition-all text-center"
                //onChange={async (e) =>{ dispatch(changeSlideCount(e.target.value)); await handleGenerate(e.target.value)}}
                min={2}
                max={10}
              />
              {/*increment and decrement button */}
              <Button 
                onClick={async () => { dispatch(changeSlideCount(number_of_slides + 1)); await handleGenerate(number_of_slides + 1)}}
                icon={<PlusOutlined  />}
               style={{marginLeft:'2px'}}
              />
              <Button 
                onClick={async () => { dispatch(changeSlideCount(number_of_slides - 1)); await handleGenerate(number_of_slides - 1)}}
                icon={<MinusOutlined />}
                style={{marginLeft:'2px'}}
              />
            </div>
          </div>
        </div>

        <Divider className="my-6 border-gray-100" />


        {/* randomize settings */}
        <div className="relative w-full">
  <div className="flex flex-col sm:flex-row items-center gap-3 p-3 sm:p-4 bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl shadow-sm">
    
    {/* Title - Full width on mobile, flex-1 on desktop */}
    <h3 className="w-full sm:flex-1 text-center sm:text-left text-base sm:text-lg font-medium bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
      Randomize Design
    </h3>
    
    {/* Button - Full width on mobile, auto width on desktop */}
    <Button
      className="w-full sm:w-auto flex items-center justify-center gap-2 px-4 sm:px-6 py-2 
                 bg-white hover:bg-gradient-to-r hover:from-purple-500 hover:to-pink-500 
                 hover:text-white transition-all duration-300 border border-purple-200 
                 rounded-lg shadow-sm hover:shadow-md min-h-[40px]"
      onClick={handleRandomize} 
    > 
      <span className="animate-spin-slow text-lg">🎲</span>
      <span className="text-sm sm:text-base">Shuffle</span>
    </Button>
  </div>
 

  {/* Animated dot - Hidden on mobile */}
  <div className="hidden sm:block absolute -top-2 -right-2">
    <span className="flex h-3 w-3">
      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-purple-400 opacity-75"></span>
      <span className="relative inline-flex rounded-full h-3 w-3 bg-purple-500"></span>
    </span>
  </div>
</div>
         {/* randomize settings */}




         {/* openai api key */}
                      <div className="space-y-4 p-4 bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl shadow-sm">
                {/* Title */}
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-lg">✨</span>
                  <h3 className="text-base sm:text-lg font-medium bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
                    AI Content Generator
                  </h3>
                  {userData?.subscription === false && <Tooltip title="Upgrade to unlock this feature"><LockOutlined className="text-gray-400 text-base" /></Tooltip>}
                </div>

                {/* TextArea with custom styling */}
                <TextArea 
                  placeholder="Enter a topic to generate amazing content..."
                  value={contentPrompt}
                  onChange={(e)=>setContentPrompt(e.target.value)}
                  className="w-full min-h-[120px] p-4 border border-purple-200 rounded-xl 
                            focus:border-purple-400 focus:ring-2 focus:ring-purple-200 
                            placeholder-gray-400 text-gray-600 transition-all duration-300
                            resize-none bg-white/80 backdrop-blur-sm"
                            disabled={userData?.subscription === false}
                  style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}
                />

                {/* Generate Button */}
                <Button
                  type="primary"
                  onClick={() => handleAIGenerate()}
                  disabled={handledisableAIGenerate()}
                  loading={loading}
                  className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-2 h-12
                            bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 
                            hover:to-pink-700 border-0 rounded-xl shadow-md hover:shadow-lg 
                            transition-all duration-300"
                >
                  <span className="text-lg">🪄</span>
                  <span className="font-medium">Generate Content</span>
                  <span className="ml-1 animate-pulse">✨</span>
                </Button>

                {/* Helper Text */}
                <p className="text-xs text-gray-500 text-center sm:text-left">
                  Let AI craft engaging content for your carousel
                </p>
</div>
         {/* openai api key */}

        {/* Section: General Settings */}
        <div>
          <h3 className="flex items-center gap-2 text-base font-semibold mb-4 text-gray-800">
            <span>⚙️ General Settings</span>
          </h3>
          <div className="space-y-4">
            <div>
              <label className="flex items-center text-sm text-gray-600 mb-2">
                📐 Preset Template
                <Tooltip title="Select a preset template size">
                  <InfoCircleOutlined className="ml-2 text-gray-400 text-xs" />
                </Tooltip>
              </label>
              <Select
                className="w-full"
                value={template_type.name}
                options={template_options}
                onChange={(value, data) => {
                  dispatch(changeTemplate(data.data));
                  setSelectedTemplate(data);
                }}
              />
            </div>

            <div>
              
             
              <label className="flex items-center text-sm text-gray-600 mb-2">
                🎨 Design Elements
                <Tooltip title="Select design elements">
                  <InfoCircleOutlined className="ml-2 text-gray-400 text-xs" />
                </Tooltip>
              </label>
              <label className="flex items-center gap-2 px-3 py-2 rounded-md bg-gray-50/50 backdrop-blur-sm border border-gray-100">
                <span className="text-purple-600">✨</span>
                <span className="text-sm font-medium">
                  {template?.pattern ? template.pattern.toUpperCase() : isMobile ? 'Select Design' : 'Select a Design Pattern'}
                </span>
              </label>
              <Button 
                onClick={showModal}
                
                className="w-full bg-red-500  hover:bg-red-600 border border-gray-200  text-white rounded-lg transition-all"
              >
                {isMobile ? 'Choose Design🎨' : 'Choose Design Template 🎨'}
              </Button>
             
              <Modal 
                  title="Choose Template" 
                  open={isModalOpen} 
                  onOk={handleOk} 
                  onCancel={handleCancel}
                  width={600}
                  footer={[
                    <Button key="cancel" onClick={handleCancel}>
                      Cancel
                    </Button>,
                    <Button 
                      key="submit" 
                      type="primary"
                      className="bg-purple-600 hover:bg-purple-700"
                      onClick={handleOk}
                    >
                      Apply Template
                    </Button>,
                  ]}
                >
                  <TemplateSelector />
                </Modal>
            </div>
          </div>
        </div>

        <Divider className="my-6 border-gray-100" />

        {/* Section: Color Palette */}
        <div>
          <h3 className="flex items-center gap-2 text-base font-semibold mb-4 text-gray-800">
            <span>🎨 Color Palette</span>
            <Tooltip title="Select a color palette">
              <InfoCircleOutlined className="text-gray-400 text-xs" />
            </Tooltip>
          </h3>
          <Pallette />
          
          {/* Add this new section for color indicators */}
          <div className="flex justify-between items-center mt-4 px-2">
            <div className="flex flex-col items-center">
              <div 
                className="w-8 h-8 rounded-full border border-gray-200 shadow-sm"
                style={{ backgroundColor: currentColorPalletes?.first_color || '#000000' }}
              />
              <span className="text-xs text-gray-500 mt-1">Primary</span>
              <span className="text-xs font-mono text-gray-400">
                {currentColorPalletes?.first_color || '#000000'}
              </span>
            </div>

            <div className="flex flex-col items-center">
              <div 
                className="w-8 h-8 rounded-full border border-gray-200 shadow-sm"
                style={{ backgroundColor: currentColorPalletes?.second_color || '#000000' }}
              />
              <span className="text-xs text-gray-500 mt-1">Secondary</span>
              <span className="text-xs font-mono text-gray-400">
                {currentColorPalletes?.second_color || '#000000'}
              </span>
            </div>

            <div className="flex flex-col items-center">
              <div 
                className="w-8 h-8 rounded-full border border-gray-200 shadow-sm"
                style={{ backgroundColor: currentColorPalletes?.third_color || '#000000' }}
              />
              <span className="text-xs text-gray-500 mt-1">Accent</span>
              <span className="text-xs font-mono text-gray-400">
                {currentColorPalletes?.third_color || '#000000'}
              </span>
            </div>
          </div>
        </div>

        <Divider className="my-6 border-gray-100" />

        {/* Section: Text Styling */}
        <div>
          <h3 className="flex items-center gap-2 text-base font-semibold mb-4 text-gray-800">
            <span>✍️ Text Styling</span>
          </h3>
          
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              {/* Font Size */}
              <div>
                <label className="flex items-center text-sm text-gray-600 mb-2">
                  📏 Size
                  <Tooltip title="Select a font size">
                    <InfoCircleOutlined className="ml-2 text-gray-400 text-xs" />
                  </Tooltip>
                </label>
                <Radio.Group 
                  value={font_size} 
                  onChange={(e) => setFont_size(e.target.value)}
                  className="flex gap-2"
                >
                  <Radio.Button value="small-font" className="flex-1 text-center">
                    <FontColorsOutlined style={{fontSize:'10px'}} />
                  </Radio.Button>
                  <Radio.Button value="large-font" className="flex-1 text-center">
                    <FontColorsOutlined />
                  </Radio.Button>
                </Radio.Group>
              </div>

              {/* Alignment */}
              <div>
                <label className="flex items-center text-sm text-gray-600 mb-2">
                  ↔️ Align
                  <Tooltip title="Select alignment">
                    <InfoCircleOutlined className="ml-2 text-gray-400 text-xs" />
                  </Tooltip>
                </label>
                <Radio.Group 
                  value={alignment} 
                  onChange={(e) => { setAlignment(e.target.value); dispatch(changeFontAlignment(e.target.value))}}
                  className="flex gap-2"
                >
                  <Radio.Button value="left-alignment" className="flex-1 text-center">
                    <AlignLeftOutlined />
                  </Radio.Button>
                  <Radio.Button value="center-alignment" className="flex-1 text-center">
                    <AlignCenterOutlined />
                  </Radio.Button>
                </Radio.Group>
              </div>
            </div>

            {/* Font Style */}
            <div>
              <label className="flex items-center text-sm text-gray-600 mb-2">
                🔤 Font Style
                <Tooltip title="Select a font">
                  <InfoCircleOutlined className="ml-2 text-gray-400 text-xs" />
                </Tooltip>
              </label>
              <Select 
                className="w-full" 
                value={fontStyle} 
                options={font_style}
                onChange={(e) => { dispatch(changeFontStyle(e));}}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideScreen;




